import { render } from "./singleUserForm.vue?vue&type=template&id=2c0c12dc"
import script from "./singleUserForm.vue?vue&type=script&lang=js"
export * from "./singleUserForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__